module.exports = __webpack_public_path__ + "img/電気回路_1_1_1.960532d1.png";